import React, { createContext, useContext, useState, ReactNode } from 'react'

export type ButtonsActionModal = {
  title: string
  isGreen?: boolean
  onPress: () => void
}

export type ModalProps = {
  title: string
  text?: string
  buttons?: ButtonsActionModal[]
}

interface ModalContextType {
  isModalVisible: boolean
  modalProps: ModalProps
  showModal: (props: ModalProps) => void
  hideModal: () => void
}

const ModalContext = createContext<ModalContextType | undefined>(undefined)

interface ModalProviderProps {
  children: ReactNode
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [isModalVisible, setModalVisible] = useState<boolean>(false)

  const initialModalProps: ModalProps = {
    title: '',
    text: '',
    buttons: [],
  }

  const [modalProps, setModalProps] = useState<ModalProps>(initialModalProps)

  const showModal = (props: ModalProps) => {
    setModalProps(props)
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
  }

  return (
    <ModalContext.Provider value={{ isModalVisible, modalProps, showModal, hideModal }}>
      {children}
    </ModalContext.Provider>
  )
}

export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext)
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider')
  }
  return context
}
